import React from 'react';
import { motion } from 'framer-motion';
import { HomeIcon, SparklesIcon, ShieldCheckIcon, StethoscopeIcon, PaintbrushIcon, GemIcon } from 'lucide-react';
const FEATURES = [{
  icon: HomeIcon,
  title: 'Own Your Home',
  text: 'Buy your residence and build equity — no costly entrance fees.'
}, {
  icon: SparklesIcon,
  title: 'Live Worry-Free',
  text: 'We handle exterior upkeep, landscaping, and snow removal.'
}, {
  icon: ShieldCheckIcon,
  title: 'Stay Independent',
  text: 'Your home stays your home — never relocate over changing care needs.'
}, {
  icon: StethoscopeIcon,
  title: 'Keep Your Healthcare Choice',
  text: 'Continue with the doctors and providers you know and trust.'
}, {
  icon: PaintbrushIcon,
  title: 'Personalize Your Space',
  text: 'Customize your residence to fit your lifestyle — a rare advantage.'
}, {
  icon: GemIcon,
  title: 'Resort-Style Amenities',
  text: 'Activities, wellness programs, excursions, and concierge services.'
}];
export function WhyResidents() {
  return <section id="why" className="w-full bg-white py-20 lg:py-28" data-id="element-104" data-mp="1izt43k7tac5a">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-105" data-mp="1ixgd6hk2srg3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-106" data-mp="1xp8qko0b7vf6">
          <h2 className="font-display text-3xl leading-tight text-forest sm:text-4xl" data-id="element-107" data-mp="1sxh2ck4mm1s7">
            Why Residents Love Brightwood
          </h2>
          <div className="mx-auto mt-4 h-0.5 w-16 bg-gold" data-id="element-108" data-mp="26nkgentcqp6k" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-md shadow-md" data-id="element-109" data-mp="22ntm4a4m9qxa">
          <img src="https://cdn.magicpatterns.com/uploads/in746n3QXW6J7A3zB2u1RP/Living-Room.png" alt="A bright, elegantly furnished Brightwood residence living room" className="h-56 w-full object-cover object-center sm:h-64" data-id="element-110" data-mp="hb8w3sk8gxzb" />
        </motion.div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-111" data-mp="2qbtxvljru4ca">
          {FEATURES.map((feature, i) => {
          const Icon = feature.icon;
          return <motion.article key={feature.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i % 3 * 0.1
          }} className="group flex gap-4 rounded-md border border-sand bg-cream p-5 transition-shadow hover:shadow-lg sm:flex-col sm:gap-0" data-id="element-112" data-mp="30bknb8th5t5i" data-mpi={i}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-forest transition-colors group-hover:bg-forest-dark" data-id="element-113" data-mp="1wtm8knirzng">
                  <Icon className="h-6 w-6 text-gold-light" data-id="element-114" data-mp="3o75wynnn58bq" />
                </span>
                <div className="sm:mt-4" data-id="element-115" data-mp="3k5kpxixsfo9g">
                  <h3 className="font-display text-xl leading-snug text-forest" data-id="element-116" data-mp="3k6m3bu2a0muc">
                    {feature.title}
                  </h3>
                  <p className="mt-2 font-serif leading-relaxed text-neutral-600" data-id="element-117" data-mp="fq2qk6wm1uz4">
                    {feature.text}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}